<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="tes-card pa-7" no-gutters>
    <!--title-->
    <v-col cols="12">
      <h1 class="tes-card__title">{{$t('pages.agreementConclusionChangeOwner.title')}}</h1>
    </v-col>
    <!--steps nav -->
    <template>
      <v-col cols="12" v-if="type !== 'see'">
        <v-row>
          <template v-for="(item, index) in steps">
            <v-col :key="`col-${index}`" :class="(item.step === current ? 'active ' : '') + 'step'">
              <v-row dense>
                <v-col
                  cols="2"
                  class="display-2 pt-3 text-sm-center inner font-weight-bold"
                  v-text="item.step"
                />
                <v-col v-if="currentLocale === 'ru'" cols="10" class="subtitle-1 inner font-weight-medium" v-html="item.title"/>
                <v-col v-else cols="10" class="subtitle-1 inner font-weight-medium" v-html="item.titleTat"/>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </v-col>
      <v-col cols="12">
        <!-- step component -->
        <component
          @transfer="processData"
          :formData="formData"
          @lockFwdBtn="lockFwdBtn"
          :income="steps[current-1].data"
          :is="stepComponent"
          :ref="stepComponent"
        />
        <!-- end of step component -->
      </v-col>
      <span v-if="errorMessage" cols="12">{{errorMessage}}</span>

      <v-col cols="12" class="px-5 text-sm-right">
        <p v-if="!editDisable && current !== 4" class="text-sm-left">*- {{$t('requiredFields')}}</p>
        <v-btn v-if="current > 1" outlined class="mr-5" @click="nav(false)">{{$t('buttons.back')}}</v-btn>
        <v-btn
          class="green-button white--text"
          :class="{'button-font': currentLocale === 'tat'}"
          v-if="current < steps.length"
          depressed
          :disabled="nextStepActive" 
          @click="nav(true)"
        >{{$t('buttons.next')}}
        </v-btn>
        <!--"nextStepActive" -->
        <v-btn
          class="blue-button white--text mr-5"
          :class="{'button-font': currentLocale === 'tat'}"
          v-if="current === steps.length && this.type !== 'see' && !this.completeDisabled"
          @click="doSendRequest(true)"
          depressed
          :disabled="completeDisabled || (this.type !=='see' && 
              (!this.isExistName && !this.formData.agreeContract && !(this.formData.objectLocateType == true)))"
        >{{$t('buttons.draft')}}
        </v-btn>
        <v-btn
          class="green-button white--text"
          :class="{'button-font': currentLocale === 'tat'}"
          v-if="current === steps.length"
          @click="doSendRequest(false)"
          depressed
          :disabled="completeDisabled || (this.type !=='see' && 
              (!this.isExistName && !this.formData.agreeContract && !(this.formData.objectLocateType == true)))"
        >{{$t('buttons.finish')}}
        </v-btn>
      </v-col>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"/>
      </v-overlay>
    </template>
  </v-row>
</template>

<script>
  import {mapState, mapGetters} from "vuex";

  // partial views
  import IdentificationStep from "../../../components/statements/agreement-conclusion-change-owner/IdentificationStep";
  import AddressStep from "../../../components/statements/agreement-conclusion-change-owner/AddressStep";
  import ObjectDetailsStep from "../../../components/statements/agreement-conclusion-change-owner/ObjectDetailsStep";
  import DocumentsUploadStep
    from "../../../components/statements/agreement-conclusion-change-owner/DocumentsUploadStep";
  import VerificationStep from "../../../components/statements/agreement-conclusion-change-owner/VerificationStep";

  export default {
    layout: "main",
    components: {
      IdentificationStep,
      AddressStep,
      ObjectDetailsStep,
      DocumentsUploadStep,
      VerificationStep
    },
    data() {
      return {
        current: 1,
        completeDisabled: false,
        fwdDisabled: false,
        errorMessage: null,
        loading: false,
        // собираем здесь данные для запроса
        formData: {
          userGuid: null,
          filledDate: null,
          isDraft: true,
          agreeContract: false,
        },
        type: null,
        isExistName: false,
        agreeContract: false,
      };
    },
    computed: {
      ...mapState({
        steps: state => state.statements.agreementConclusionDataChangeOwner,
        editDisable: state => state.statements.editDisable
      }),
      ...mapGetters("locale",["currentLocale"]),
      stepComponent() {
        return !!this.steps && this.steps[this.current - 1].component;
      },
      userSettings() {
        return this.$store.getters["account/userSettings"];
      },
      nextStepActive () {
        if (this.editDisable) {
          return false
        } else {
          return this.fwdDisabled
        }
      }
    },
    watch: {
      type () {
        if (this.type === 'see') {
          this.current = 1
        }
      }
    },
    mounted() {
      if (!this.steps) {
        this.$router.push('/statements/history')
      }
      if(this.$route.query.id){
        this.formData.id = this.$route.query.id
      }
      let {type} = this.$route.query;
      this.type = type;
      if (type === "see") {
        this.nav(false);
      } else {
        this.$store.dispatch('statements/setEditDisable', false)
      }
    },
    methods: {
      lockFwdBtn(doLock = true) {
        this.fwdDisabled = doLock;
      },
      nav(fwd = true) {
        this.$refs[this.stepComponent].transferData();
        fwd ? this.current++ : this.current--;
        if(!fwd){
        }
      },

      doSendRequest(isDraft = true) {

        if (this.type !== 'see') {
          this.formData.isDraft = isDraft;
          this.formData.userGuid = this.userSettings.userGuid;
          this.loading = true;
          this.formData.typeApplication = "ApplicationNewOwner";

          this.$store
            .dispatch("statements/" + "saveContractRequest", this.formData)
            .then(response => {
              this.loading = false;
              if (response.data.success){
                if(!isDraft)
                {
                this.completeDisabled = true;
                }

                this.$router.push("/")
                };
            })
            .catch(error => {
              this.loading = false;
              if(!isDraft)
              {
                this.completeDisabled = true;
              }
              // do some action here
            });
        } else {
          this.$router.push("/");
        }
      },
      processData(payload) {

        // заполнение шага с подтверждением
        if (this.stepComponent === "verification-step") {
          this.steps.find(
            item => item.component === "verification-step"
          ).data = this.formData;
          return;
        }

        switch (this.stepComponent) {
          
          case "identification-step":
            
            this.formData.document = {
              series: payload.series,
              number: payload.number,
              issuer: payload.issuer,
              issueDate: payload.issueDate,
              unitCode: payload.unitCode,
              birthDate: payload.birthDate,
              birthPlace: payload.birthPlace,
              inn: payload.inn,
              snils: payload.snils,
              phone: payload.phone
            };

            this.formData.regAddress = payload.regAddress;

            if(payload.regAddressData!= null){
            if(!this.formData.addressesData) this.formData.addressesData = [];
            let registrationsAddressExists = this.formData.addressesData.find(
              item => item.addressType === payload.regAddressData.addressType
            );

             if (!!registrationsAddressExists) {
              this.formData.addressesData[
                this.formData.addressesData.indexOf(registrationsAddressExists)
                ] = payload.regAddressData;
            } else {
              this.formData.addressesData.push(payload.regAddressData);
            }
            }
            break;
          case "object-details-step":
            
            this.formData.BuildingType = payload.BuildingType;
            this.formData.licnumber = payload.licnumber;
            this.formData.oko = payload.oko;
            this.formData.totalArea = payload.totalArea;
            this.formData.floor = payload.floor;
            this.formData.numberRooms = payload.numberRooms;
            this.formData.numberInhabitants = payload.numberInhabitants;
            this.formData.cadastralNumber = payload.cadastralNumber;
            this.formData.objectLocateType =  payload.objectLocateType;
            this.formData.settingType = payload.settingType;
            this.formData.tariffType = payload.tariffType;
            this.formData.objAddress = payload.objAddress;
            this.formData.objectAddress = payload.objectAddress;

            
            if(payload.objAddressData != null){
            if(!this.formData.addressesData) this.formData.addressesData = [];
            let objAddressExists = this.formData.addressesData.find(
              item => item.addressType === payload.objAddressData.addressType
            );

             if (!!objAddressExists) {
              this.formData.addressesData[
                this.formData.addressesData.indexOf(objAddressExists)
                ] = payload.objAddressData;
            } else {
              this.formData.addressesData.push(payload.objAddressData);
            }
            }

            if(this.type != 'see'){
            
              let objAdd = this.formData.addressesData.find(
                item => item.addressType === "802740002");
              
              let data = {
                  cadastralNumber: this.formData.cadastralNumber,
                  objAddress: objAdd ? objAdd.house : null,
                  flat: objAdd ? objAdd.flat : null
                }

              this.$store
              .dispatch("statements/getPrincipalInfo", data)
              .then((res) => {
                this.isExistName = res.isExistName;
                this.formData.principals = res.principals;
              });         
            }

            break;

          case "documents-upload-step":
            this.formData.email = payload.email;
            this.formData.emailCheck = payload.emailCheck;
            this.formData.okooffice = payload.okooffice
            this.formData.files = [];
            let fKeys = Object.keys(payload.files);
            fKeys.forEach(i => {
              this.formData.files.push(payload.files[i]);
            });
            break;
        }
      }
    }
  };
</script>
<style scoped lang="scss">
  $grey: #b3b3b3;

  @mixin tran {
    transition-duration: 0.2s;
    transition-property: color, border-bottom-color;
  }

  h1 {
    @extend %h1;
  }

  .step {
    color: $main-grey;

    div.inner {
      line-height: 20px;
      border-bottom: 4px solid $grey;
      padding-bottom: 15px;
      @include tran;
    }

    &.active {
      @extend %orange-text;

      div.inner {
        border-bottom-color: $main-orange;
        @include tran;
      }
    }
  }
  .button-font{
  font-family: Rubik-Medium !important;
  white-space: normal;
}
</style>

